import { component } from 'picoapp'

export default component((node) => {
  const dropdown = node.querySelector('[data-dropdown-select]')
  const targets = node.querySelectorAll('[data-dropdown-options]')

  function updateVisibleGroup(value) {
    targets.forEach((el) => {
      el.classList.toggle('tw-hidden', el.dataset.dropdownOptions !== value)
    })
  }

  dropdown.addEventListener('change', (e) => {
    updateVisibleGroup(e.target.value)
  })
})
